<script setup>
/*==================================================================*/
/*================== SCRIPT FLEX WRAP BASE =========================*/
/*==================================================================*/

import { computed, defineProps } from 'vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    gap: {
        type: String,
        default: '10px'
    },
    minWidth: {
        type: String,
        default: '300px'
    }
});

/*==================================================================*/
/*================== STYLE COMPUTADO ===============================*/
/*==================================================================*/

const wrapStyle = computed(() => ({
    gap: props.gap,
    '--min-width': props.minWidth
}));

</script>

<template>

    <div class="c-flex-wrap" :style="wrapStyle">

        <slot></slot>

    </div>

</template>

<style scoped>

/*==================================================================*/
/*================== STYLE FLEX WRAP BASE ==========================*/
/*==================================================================*/

.c-flex-wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.c-flex-wrap > * {
    flex: 1 1 var(--min-width);
}

</style>
